// File: src/App.js
import React, { useState, useContext } from "react";
import { GlobalContext } from "./context/GlobalContext";
import Api from "./api/api";

import { PrimaryButton } from "./components/Button";
import { Input } from "./components/Input";

function Login() {
  const { globalState } = useContext(GlobalContext);
  const [step, setStep] = useState(1); // Control flow of authentication steps
  const [phone, setPhone] = useState("");
  const [fullNumber, setFullNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [loadingPhone, setLoadingPhone] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const onSignInSubmit = async (e) => {
    e.preventDefault();
    if (phone.length < 10) {
      alert("Please enter a valid phone number.");
      return;
    }

    setLoadingPhone(true);
    setErrorMsg(null);

    let phoneNumber = phone.replace(/[^0-9]/g, "");
    phoneNumber = `+1${phoneNumber}`;

    try {
      const result = await Api.sendOTP(phoneNumber);
      if (result.success) {
        setFullNumber(phoneNumber);
        setStep(2); // Move to OTP step
      } else {
        setErrorMsg(result.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error during sign in:", error);
      setErrorMsg(error.message || "An error occurred while sending OTP");
    } finally {
      setLoadingPhone(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    setLoadingOtp(true);
    setErrorMsg(null);

    try {
      await Api.verifyOTP(fullNumber, otp);
      // Navigation will be handled by useAuthRedirect when auth state updates
    } catch (error) {
      console.error("Error during code verification:", error);
      setErrorMsg(error.message || "OTP verification failed");
      setLoadingOtp(false);
    }
  };

  if (globalState.loading || globalState.isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-24 w-auto rounded-lg"
              src="/gist_logo.jpg"
              alt="gist"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            className="mx-auto h-24 w-auto rounded-lg"
            src="/gist_logo.jpg"
            alt="gist"
          />
        </div>
        {step === 1 && (
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm transition-opacity duration-500">
            <form className="space-y-6" onSubmit={onSignInSubmit}>
              <div>
                <div className="mt-2">
                  <div>
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                    >
                      Phone number
                    </label>
                    <div className="mt-2 flex space-x-2">
                      <select className="px-4 block w-20 rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6">
                        <option>+1</option>
                      </select>
                      <input
                        onChange={(e) => setPhone(e.target.value)}
                        id="phone"
                        name="phone"
                        autoComplete="phone"
                        required
                        className="px-4 block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <PrimaryButton type="submit" disabled={loadingPhone}>
                {loadingPhone ? "Sending..." : "Next"}
              </PrimaryButton>
              {errorMsg && (
                <div className="mt-2 text-sm text-red-500 dark:text-red-400">{errorMsg}</div>
              )}
            </form>
          </div>
        )}
        {step === 2 && (
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm transition-opacity duration-500">
            <form className="space-y-6" onSubmit={verifyOtp}>
              <div>
                <div className="mt-2">
                  <Input
                    label="Enter OTP"
                    type="text"
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
              </div>

              <PrimaryButton type="submit" disabled={loadingOtp}>
                {loadingOtp ? "Verifying..." : "Verify OTP"}
              </PrimaryButton>
              {errorMsg && (
                <div className="mt-2 text-sm text-red-500 dark:text-red-400">{errorMsg}</div>
              )}
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
